module.exports = __webpack_public_path__ + "static/media/supportImage.16ca16b5.jpg";